<ng-container [ngSwitch]="subType">
  <lm-form-content-search #LMFormSearchComponent
      *ngSwitchCase="layoutSubType.SEARCH"
      [formSpec]="formSpec"
      [formOptions]="formOptions"
      [columnarText]="columnarText"
      [specFields]="specFields"
      [layout]="layout"
      [model]="model"
      [formState]="formState"
      [placeHolder]="placeHolder"
      [formPersonalization]="formPersonalization"
      (fieldEvent)="onFieldEvent($event)"
      (searchButtonClicked)="onSearchClicked($event)"
      (clearSearchButtonClicked)="onClearSearchClicked($event)"
  ></lm-form-content-search>
  <lm-form-content-form #LMPageContextComponent
      *ngSwitchCase="layoutSubType.PAGE_CONTEXT"
      [formSpec]="formSpec"
      [formOptions]="formOptions"
      [specFields]="specFields"
      [layout]="layout"
      [model]="model"
      [formState]="formState"
      [placeHolder]="placeHolder"
      [formPersonalization]="formPersonalization"
      (fieldEvent)="onFieldEvent($event)"
  ></lm-form-content-form>
  <lm-form-content-form #LMFormStandardComponent
      *ngSwitchCase="layoutSubType.STANDARD"
      [formSpec]="formSpec"
      [formOptions]="formOptions"
      [specFields]="specFields"
      [layout]="layout"
      [model]="model"
      [formState]="formState"
      [placeHolder]="placeHolder"
      [parentIsModal]="parentIsModal"
      [formPersonalization]="formPersonalization"
      (fieldEvent)="onFieldEvent($event)"
  ></lm-form-content-form>
  <lm-form-content-composite #LMComposite
      *ngSwitchCase="layoutSubType.COMPOSITE"
      [model]="model"
      [formUrlInfo]="formUrlInfo"
      [formSpec]="formSpec"
      [specFields]="specFields"
      [formOptions]="formOptions"
      [placeHolder]="placeHolder"
      [formState]="formState"
      [formPersonalization]="formPersonalization"
      [parentIsModal]="parentIsModal"
      (fieldEvent)="onFieldEvent($event)"
      (contentModified)="onContentModified($event)"
      (updateToolbarStateEvent)="onUpdateToolbarStateEvent($event)"
      (sendContextMessageEvent)="onSendContextMessageEvent($event)"
      (sendShortcutMessage)="onSendShortcutMessage($event)"
      (specialActionsToolbarButtonEvent)="onSpecialActionToolbarButtonEvent($event)"
      (panelTransactionEvent)="onPanelTransactionEvent($event)"
       (drillAroundEvent)="onDrillAroundEvent($event)"
  ></lm-form-content-composite>
  <lm-form-content-stepprocess #LMStepProcessComponent
      *ngSwitchCase="layoutSubType.STEP_PROCESS_OR_WIZARD"
      [formUrlInfo]="formUrlInfo"
      [formSpec]="formSpec"
      [model]="model"
      [specFields]="specFields"
      [placeHolder]="placeHolder"
      [formState]="formState"
      [formPersonalization]="formPersonalization"
      (fieldEvent)="onFieldEvent($event)"
      (stepPanelEvent)="onStepPanelEvent($event)"
      (contentModified)="onContentModified($event)"
      (updateToolbarStateEvent)="onUpdateToolbarStateEvent($event)"
      (sendContextMessageEvent)="onSendContextMessageEvent($event)"
      (specialActionToolbarButtonEvent)="onSpecialActionToolbarButtonEvent($event)"
      (panelTransactionEvent)="onPanelTransactionEvent($event)"
      (drillAroundEvent)="onDrillAroundEvent($event)"
  ></lm-form-content-stepprocess>
  <lm-form-content-instancechart #LMInstanceChart
      *ngSwitchCase="layoutSubType.INSTANCE_COUNT_CHART"
      [formSpec]="formSpec"
      [model]="model"
      [specFields]="specFields"
      [placeHolder]="placeHolder"
      [formState]="formState"
      [formPersonalization]="formPersonalization"
      [fromDataView]="fromDataView"
      (fieldEvent)="onFieldEvent($event)"
  ></lm-form-content-instancechart>
  <lm-form-content-manual-representation #LMManualRepresentation
      *ngSwitchCase="layoutSubType.MANUAL_REPRESENTATION"
      [formSpec]="formSpec"
      [model]="model"
      [specFields]="specFields"
      [placeHolder]="placeHolder"
      [formState]="formState"
      [formPersonalization]="formPersonalization"
      [fromDataView]="fromDataView"
      (fieldEvent)="onFieldEvent($event)"
      (contentModified)="onContentModified($event)"
  ></lm-form-content-manual-representation>
  <lm-form-content-menu #LMMenu
      *ngSwitchCase="layoutSubType.MENU_LAYOUT"
      [layout]="layout"
      [specFields]="specFields"
      [formSpec]="formSpec"
      [formOptions]="formOptions"
      [model]="model"
      [formState]="formState"
      [placeHolder]="placeHolder"
      [formPersonalization]="formPersonalization"
      (fieldEvent)="onFieldEvent($event)"
  ></lm-form-content-menu>
  <lm-form-content-matrix #LMMatrix
      *ngSwitchCase="layoutSubType.MATRIX"
      [formUrlInfo]="formUrlInfo"
      [formSpec]="formSpec"
      [specFields]="specFields"
      [formOptions]="formOptions"
      [placeHolder]="placeHolder"
      [formState]="formState"
      [model]="model"
      [matrixFormSpec]="formSpec.busFormSpec"
      [matrixView]="fromDataView"
      (matrixActionEvent)="onRunMatrixActionEvent($event)"
      (fieldEvent)="onFieldEvent($event)"
      (contentModified)="onContentModified($event)"
  ></lm-form-content-matrix>
</ng-container>

<lm-report-field-picker-drawer [canShowDrawer]="canShowReportFieldPickerDrawer"></lm-report-field-picker-drawer>
